import { useEffect, useState } from 'react';
import { getOptimisedImageUrl } from '@nykaa/image-utils';
import { CROP_STRATEGY } from '@nykaa/image-utils/constants';
import { devicesWidths } from '../../layouts/ImageVideoWrapper/constants';
/**
 * This hook used to return an optimised image/video from imagekit.
 * @param url url needs to be optimised through https://imagekit.io .
 * @param isDesktop boolean value to set the max width.
 * @param columnsInRow this is used to divide the width into the pieces for column grids.
 * @param columnsInRow this is used to enable the new imagekit implementation.
 * @returns this returns the optimised image and video.
 * @author aviralnykaa
 */
const useScaleUrl = (url, isDesktop, columnsInRow, useNewOptimizationTechnique = false) => {
    const { max: maxMobileWidth } = devicesWidths === null || devicesWidths === void 0 ? void 0 : devicesWidths.mobile;
    const { max: maxDesktopWidth } = devicesWidths === null || devicesWidths === void 0 ? void 0 : devicesWidths.desktop;
    const [maxWidth, setMaxWidth] = useState(maxMobileWidth);
    useEffect(() => {
        if (isDesktop) {
            setMaxWidth(maxDesktopWidth);
        }
        setMaxWidth((maxWidth / (columnsInRow || 1)));
    }, [isDesktop, columnsInRow, maxMobileWidth]);
    const { src } = getOptimisedImageUrl({
        url,
        width: maxWidth,
        cropStrategy: CROP_STRATEGY.padResize,
        newImageUrlEnabled: useNewOptimizationTechnique,
    });
    return {
        scaleUrl: src,
    };
};
export default useScaleUrl;
